<template>
  <landing-page
    label="services.services"
    description="services.introDesc"
    labelColor="#603813"
    descColor="#4E4E4E"
    :eggImgObj="{ componentName: 'services', imgName: 'servicesIntro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const servicesStore = useServicesStore();
const commonStore = useCommonStore();
const router = useRouter();
const i18n = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>